import { useRef, useState } from 'react';

export interface SaveChangesGuard {
  isConfirmOpen: boolean;
  confirmSafeToLeave: () => Promise<boolean>;
  settleConfirm: (proceed: boolean) => void;
  onConfirmOpenChange: (open: boolean) => void;
}

export function useSaveChangesGuard(getIsDirty: () => boolean): SaveChangesGuard {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const confirmResolverRef = useRef<((proceed: boolean) => void) | null>(null);

  function confirmSafeToLeave(): Promise<boolean> {
    if (!getIsDirty()) return Promise.resolve(true);
    if (confirmResolverRef.current) return Promise.resolve(false);
    return new Promise((resolve) => {
      confirmResolverRef.current = resolve;
      setIsConfirmOpen(true);
    });
  }

  function settleConfirm(proceed: boolean) {
    const resolve = confirmResolverRef.current;
    confirmResolverRef.current = null;
    setIsConfirmOpen(false);
    resolve?.(proceed);
  }

  function onConfirmOpenChange(open: boolean) {
    if (!open) settleConfirm(false);
  }

  return { isConfirmOpen, confirmSafeToLeave, settleConfirm, onConfirmOpenChange };
}
